import React, { useState } from 'react'
import HappyIcon from '../../icons/HappyIcon'
import './OrderInfoComponent.css'

const LoyaltyCard = ({ orderId }) => {
  const [registrationResult, setRegistrationResult] = useState(null)

  const handleRegisterPoints = async () => {
    const token = localStorage.getItem('token')
    if (!token) {
      window.location.href = '/register'
      return
    }
    try {
      const response = await fetch(process.env.REACT_APP_API_URL + '/loyalty/register-order', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ order_id: orderId })
      })
      const result = await response.json()

      setRegistrationResult(result)
    } catch (error) {
      console.error('Error:', error.message)
    }
  }

  return (
    <div
      style={{
        border: '1px solid #3FC50066',
        backgroundColor: '#3FC5001F',
        padding: '16px',
        borderRadius: '8px',
        maxWidth: '400px'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
        <div style={{ marginRight: '8px' }}>
          <HappyIcon />
        </div>
        <div>
          <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.4', color: '#2E9000' }}>
            Twoje zamówienie będzie wkrótce gotowe do wydania, a teraz proponujemy skorzystać się z programu
            lojalnościowego!
          </p>
        </div>
      </div>
      <button
        onClick={handleRegisterPoints}
        style={{
          width: '100%',
          padding: '8px',
          borderRadius: '50px',
          background: '#3fc500',
          border: 'none',
          height: '40px',
          textAlign: 'center',
          fontFamily: 'Poppins',
          fontSize: '16px',
          fontWeight: '500',
          lineHeight: '27px',
          color: '#fff'
        }}
      >
        Kliknij tu żeby zacząć zbierać punkty
      </button>

      {registrationResult && (
        <div className='info-box'>
          {registrationResult.success ? (
            <div>
              <p style={{ margin: '8px 0', fontWeight: 'bold', color: '#2E9000' }}>
                Gratulacje! Otrzymałeś {registrationResult.data.points} punktów.
              </p>
              {registrationResult.data.products.map(product => {
                const productNameObj = product.product.name.find(item => item.default) || product.product.name[0]
                return (
                  <li key={product.id} style={{ color: '#2E9000' }}>
                    Product: {productNameObj.text}, Ilość: {product.count}
                  </li>
                )
              })}
            </div>
          ) : (
            <div>
              {registrationResult.errors.map((error, index) => (
                <p key={index} style={{ margin: '8px 0', color: '#2E9000' }}>
                  {error}
                </p>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default LoyaltyCard
